import React from 'react'
import * as url from '_routes/url-names'
import AuthRoute from '_routes/authenticated-route'

const UserProfile = React.lazy(() => import('_containers/settings/user-profile'))
const GroupProfile = React.lazy(() => import('_containers/settings/group-profile'))
const CompanyProfile = React.lazy(() => import('_containers/settings/company-profile'))
const Departments = React.lazy(() => import('_containers/settings/departments'))
const Users = React.lazy(() => import('_containers/settings/users'))
const CreateUser = React.lazy(() => import('_containers/settings/create-user'))
const EditUser = React.lazy(() => import('_containers/settings/edit-user'))
const Permission = React.lazy(() => import('_containers/settings/permission'))
const CVDatabase = React.lazy(() => import('_containers/settings/cv-database'))
const CompanyDocs = React.lazy(() => import('_containers/settings/company-docs'))
const RecruitmentTemplates = React.lazy(() => import('_containers/settings/recruitment-templates'))
const RecruitmentMailings = React.lazy(() => import('_containers/settings/recruitment-mailings'))
const CompanySelection = React.lazy(() => import('_containers/settings/company-selection'))
const RecruitmentImages = React.lazy(() => import('_containers/settings/recruitment-images'))

export default [
  {
    path: url.COMPANY + url.INST_MY_PROFILE,
    element: <AuthRoute component={UserProfile} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_GROUP,
    element: <AuthRoute component={GroupProfile} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_COMPANY,
    element: <AuthRoute component={CompanyProfile} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_DEPARTMENTS,
    element: <AuthRoute component={Departments} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_USERS,
    element: <AuthRoute component={Users} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_USERS + url.INST_NY,
    element: <AuthRoute component={CreateUser} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_USERS + url.PAR_ID,
    element: <AuthRoute component={EditUser} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_PERMISSION,
    element: <AuthRoute component={Permission} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_CV_DB,
    element: <AuthRoute component={CVDatabase} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_FILER,
    element: <AuthRoute component={CompanyDocs} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_MALLAR,
    element: <AuthRoute component={RecruitmentTemplates} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_UTSKICK,
    element: <AuthRoute component={RecruitmentMailings} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_URVAL,
    element: <AuthRoute component={CompanySelection} />
  },
  {
    path: url.COMPANY + url.INSTALLNINGAR + url.INST_BILDBANK,
    element: <AuthRoute component={RecruitmentImages} />
  }
]
